import React, { useRef } from "react";
import { Grid, Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { InputField } from "../textBox/InputField";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import "./Section.scss";
import Buttons from "../button/Button";
import FormDropZone from "../../../library/dropZone/FormDropZone";
import ImageUploader from "../../../library/custom/media/ImageEditor ";
import TextEditor from "../textEditor/TextEditor";

export default function Section(props) {
  const {
    singleSection,
    keyNo,
    handleOnChangeSectionForm,
    sectionImageUpload,
    isErrorSectionName = false,
    id,
    cancelSectionList,
    deleteImageURL,
    sectionFileUploads,
    deleteUrlURL,
    isCloneOf,
    lessonName,
    errors,
  } = props;
  const editor = useRef(null);
  const disabl = isCloneOf && singleSection.videoLink ? true : false;
  return (
    <>
      <div className="overideSection" key={keyNo}>
        <div className="sectionBox">
          <h1 className="title">{`Section${keyNo}`}</h1>
          <Grid item container mt={3}>
            <Grid lg={12} xs={12} sm={12} md={12}>
              <ImageUploader
                key={singleSection.id}
                handleFileChange={(filesPath, fileDataId) =>
                  sectionImageUpload(filesPath, fileDataId)
                }
                imageUrl={
                  singleSection.imgFilesUrl ? singleSection.imgFilesUrl : []
                }
              />
            </Grid>
          </Grid>
          <Grid item container mt={1} spacing={2}>
            <Grid item lg={12} xs={12} sm={12} md={8}>
              <FormControl fullWidth>
                <FormLabels label="Add  Text" />
                <TextEditor
                  value={singleSection.Text}
                  onChange={(content) => {
                    handleOnChangeSectionForm(content, singleSection, "Text");
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid item container mt={1} spacing={2}>
            <Grid item lg={12} xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <InputField
                  fullWidth={true}
                  type="text"
                  id="embededVideoLink"
                  label="Embed Video Link"
                  placeholder="Embed Video Link"
                  value={
                    disabl
                      ? lessonName + " " + "Video"
                      : singleSection.embededVideoLink
                  }
                  isError={isErrorSectionName}
                  onChange={(e) =>
                    handleOnChangeSectionForm(
                      e,
                      singleSection,
                      "embededVideoLink"
                    )
                  }
                  disabled={disabl}
                />
              </FormControl>
              {errors && <div className="error">Please add proper link</div>}
            </Grid>
          </Grid>
          <Grid item container mt={4}>
            <Grid lg={12} xs={12} sm={12} md={12}>
              <FormDropZone
                key={singleSection.id}
                label={"Add Document"}
                id="uploadDocs"
                paraText1={"Drop the file here ..."}
                paraText2={"Drop Document here, "}
                paraText3={"or Browse"}
                handleFileChange={(photo, id) => sectionFileUploads(photo, id)}
                imageUrl={
                  singleSection.docFilesUrl ? singleSection.docFilesUrl : []
                }
                deleteImageURL={(url) => deleteUrlURL(url)}
                fileType={10}
                isDynamics={false}
                isMuliple={false}
                isDoc={true}
                isImage={false}
                allFiles={false}
              />
            </Grid>
          </Grid>
        </div>
        <div className="sectionCancel">
          <Grid item container mt={3}>
            <Grid lg={12} xs={12} sm={12} md={12}>
              <Box mb={2} textAlign="right">
                <Buttons
                  variantOutline={true}
                  onClick={() => cancelSectionList(id)}
                  label="Cancel"
                ></Buttons>
              </Box>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}
